import React from "react";
import './FullScreenLoader.css'

const FullScreenLoader = () => {
  return (
    <>
      <div class="loading">Loading&#8230;</div>
    </>
  );
};

export default FullScreenLoader;
